import React from "react";
import ContentPage, { CardGrid } from "../components/ContentPage";

const MOMENTS = [
  {
    title: "Verjaardagen",
    body: "Laat een cadeau, taart, bloemen of verrassingspakket bezorgen.",
  },
  {
    title: "Moederdag en Vaderdag",
    body: "Toon je waardering met een speciaal samengesteld pakket voor je ouders.",
  },
  {
    title: "Geboorte en babyshower",
    body: "Stuur praktische babyproducten of een feestelijk cadeau naar het gezin.",
  },
  {
    title: "Feestdagen",
    body: "Bestel speciale pakketten voor Kerst, Owru Yari, Pasen en andere feestdagen.",
  },
  {
    title: "Schoolstart",
    body: "Help kinderen en studenten met schoolbenodigdheden en dagelijkse producten.",
  },
  {
    title: "Gewoon zomaar",
    body: "Je hebt geen speciale gelegenheid nodig om iemand te laten weten dat je aan hem of haar denkt.",
  },
];

export default function MomentenPage() {
  return (
    <ContentPage
      title="Voor elk bijzonder moment"
      lead="Suriwebwinkel helpt je om belangrijke momenten samen te vieren, ook wanneer je niet zelf in Suriname aanwezig kunt zijn."
      ctaLabel="Bestel iets bijzonders"
      secondaryLabel="Cadeaubon kopen"
      secondaryTo="/cadeaubon"
    >
      <CardGrid items={MOMENTS} />
    </ContentPage>
  );
}
